import * as React from 'react';
const h = React.createElement;

export interface EmptyProps {
  description?: React.ReactNode;
}

const Empty: React.FC<EmptyProps> = function Empty(props) {
  const { description } = props;
  return h(
    'div',
    { className: 'flex flex-col items-center justify-center py-12 text-dark-500' },
    h(
      'svg',
      {
        className: 'w-16 h-16 mb-4 text-dark-600',
        fill: 'none',
        stroke: 'currentColor',
        viewBox: '0 0 24 24',
      },
      h('path', {
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 1,
        d: 'M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4',
      }),
    ),
    h('p', { className: 'text-sm' }, description || 'No Data'),
  );
};

export { Empty };
